import React from 'react';
import AdminFaqList from '../components/admin/faq/AdminFaqList';

const AdminFaq = () => {
    return (
        <AdminFaqList />
    );
};

export default AdminFaq;